import React from 'react'
import WrapperReactPage from '../General/WrapperReactPage'
import Overview from '../Overview'
import MainSliderWrapper from './MainSliderWrapper';
import hasCloseEverythingIfNotActiveSelection from '../hoc/hasCloseEverythingIfNotActiveSelection';
import TrailerPopupWrapper from '../Trailer/TrailerPopupWrapper';
import PageFrontCustomMobileWrapper from './PageFrontCustomMobileWrapper';

const PageFrontOverviewWrapper = ({
    location, 
    ads, 
    advertisements,
    movies, 
    isMobile,
    highlights,
    isOverviewPage,
    siteHeaderData, 
    programOverviewStartviewType, 
    itemSelectionsDisplay, 
    sliderAppearance,
    headerAppearance,
    contentWidth,
    itemSelections, 
    theme, 
    weischerAds,
    itemCollections, 
    overviewSubtitle,
    currentActiveSelection,
    setIdForActiveSelection,
    hasShowtimesFeature,
    hasGridTrailerFeature,
    hasGridHoverTrailer,
    mobileOverview,
    translation,
    routesData,
    stripeAppearance,
    highlightAppearance,
    mainSliderAdvertisementPositioning,
    smallSliderAppearance,
    showAvailableIn,
    programOverviewShowtimesType,
    features,
    customMobilePage,
    hasChatbot,
    isConnectedFast,
    isScrolledClass,
    match
}) => {
    const moviesRoutesData = routesData.movies.items
    let customMobilePageActive = false
    let customMobilePageElements = false

    if(customMobilePage) {
        customMobilePageActive = customMobilePage.customMobilePageActive
        customMobilePageElements = customMobilePage.customMobilePageElements
    }

    return (
        <WrapperReactPage headerAppearance={headerAppearance} hasChatbot={hasChatbot} features={features} contentWidth={contentWidth} advertisements={advertisements} isScrolledClass={isScrolledClass} extraClass={' front-overview'} movies={movies} translation={translation} buyTicketAnimation={true}>
            {movies && <MainSliderWrapper 
                itemSelectionsDisplay={itemSelectionsDisplay}
                sliderAppearance={sliderAppearance}
                itemSelections={itemSelections}
                showAvailableIn={showAvailableIn}
                itemCollections={itemCollections}
                mainSliderAdvertisementPositioning={mainSliderAdvertisementPositioning}
                ads={ads}
                advertisements={advertisements}
                weischerAds={weischerAds}
                movies={movies.items}
                theme={theme}
                moviesRoutesData={moviesRoutesData}
                translation={translation}
                currentActiveSelection={currentActiveSelection}
                setIdForActiveSelection={setIdForActiveSelection}
                features={features}
                isConnectedFast={isConnectedFast}
            />}
            
            {!isOverviewPage && (isMobile && customMobilePageActive) && movies && <PageFrontCustomMobileWrapper 
                isMobile={isMobile}
                location={location} 
                ads={ads} 
                advertisements={advertisements}
                stripeAppearance={stripeAppearance}
                highlightAppearance={highlightAppearance}
                showAvailableIn={showAvailableIn}
                smallSliderAppearance={smallSliderAppearance}
                overviewSubtitle={overviewSubtitle}
                highlights={highlights} 
                sliderAppearance={sliderAppearance}
                movies={movies.items} 
                moviesOrder={movies.order}
                siteHeaderData={siteHeaderData} 
                programOverviewStartviewType={programOverviewStartviewType} 
                itemSelectionsDisplay={itemSelectionsDisplay} 
                itemSelections={itemSelections} 
                theme={theme}
                hasShowtimesFeature={hasShowtimesFeature}
                hasGridTrailerFeature={hasGridTrailerFeature}
                hasGridHoverTrailer={hasGridHoverTrailer}
                weischerAds={weischerAds}
                itemCollections={itemCollections} 
                mobileOverview={mobileOverview}
                translation={translation}
                routesData={routesData}
                programOverviewShowtimesType={programOverviewShowtimesType}
                customMobilePageActive={customMobilePageActive}
                features={features}
                customMobilePageElements={customMobilePageElements}
                isConnectedFast={isConnectedFast}
            />}
       
            {(!customMobilePageActive || !isMobile) && movies && movies.items && <Overview 
                theme={theme}
                translation={translation}
                match={match}
                overviewSubtitle={overviewSubtitle}
                routesData={routesData}
                programOverviewShowtimesType={programOverviewShowtimesType}
                movies={movies.items}
                moviesOrder={movies.order}
                advertisements={advertisements}
                stripeAppearance={stripeAppearance}
                location={location}
                siteHeaderData={siteHeaderData}
                programOverviewStartviewType={programOverviewStartviewType}
                features={features}
                hasGridTrailerFeature={hasGridTrailerFeature}
                hasShowtimesFeature={hasShowtimesFeature}
                mobileOverview={mobileOverview}
                hasGridHoverTrailer={hasGridHoverTrailer}
                weischerAds={weischerAds}
                isConnectedFast={isConnectedFast}
            />}
            <TrailerPopupWrapper/>
        </WrapperReactPage>
    )
}


export default hasCloseEverythingIfNotActiveSelection(PageFrontOverviewWrapper)